export class BrmErrors {

  public static ERROR_NOT_IN_SHOP_YOU_THINK: string = 'sec003';
  public static ERROR_SHOP_SUSPENDED: string = 'sec014';

}
